"use client";

import { Popover, Box, MenuItem, styled, Divider } from "@mui/material";
import React, { useState } from "react";
import { Button } from "../UI";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useModal } from "@/contexts/ModalContext";
import VisibilityGroup from "../VisibilityGroup";
import MemeDeleteModal from "../DeleteModal";
import { GalleryItemPayloadV2 } from "@/types/gallery";

interface MoreButtonProps {
  meme: GalleryItemPayloadV2;
  /** Optional variant for the button styling */
  variant?: "gradient" | "outlined" | "contained" | "transparent" | "round" | "texted" | "default";
  /** Whether to show the button label or just the icon */
  showLabel?: boolean;
}

const StyledMenuItem = styled(MenuItem)({
  padding: "8px 16px",
  maxWidth: "168px",
  color: "#E8DEF8"
});

export default function MoreButton({ meme, variant = "texted", showLabel = true }: MoreButtonProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { showModal, closeModal } = useModal();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    handleClose();
    showModal(<MemeDeleteModal memeId={meme.id} />);
  };

  const handleChangeVisiblity = () => {
    handleClose();
    showModal(
      <VisibilityGroup memeId={meme.id} visibility={meme.visibility} onSuccess={closeModal} onCancel={closeModal} />
    );
  };

  return (
    <>
      <Button
        onClick={handleClick}
        startIcon={showLabel ? <MoreVertIcon /> : undefined}
        variant={variant}
        color="primary"
        size="small"
        sx={{
          minWidth: showLabel ? undefined : "40px"
        }}
      >
        {showLabel ? "More" : <MoreVertIcon />}
      </Button>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
      >
        <Box>
          <StyledMenuItem onClick={handleChangeVisiblity}>Change Visibility</StyledMenuItem>
          <Divider />
          <StyledMenuItem onClick={handleDelete}>Delete</StyledMenuItem>
        </Box>
      </Popover>
    </>
  );
}
